/**
 * Defined in:
 *   {@link file://./../../dxos/iframe.proto}
 */
export var ShellDisplay;
(function (ShellDisplay) {
    ShellDisplay[ShellDisplay["NONE"] = 0] = "NONE";
    ShellDisplay[ShellDisplay["FULLSCREEN"] = 1] = "FULLSCREEN";
})(ShellDisplay || (ShellDisplay = {}));
/**
 * Defined in:
 *   {@link file://./../../dxos/iframe.proto}
 */
export var ShellLayout;
(function (ShellLayout) {
    ShellLayout[ShellLayout["DEFAULT"] = 0] = "DEFAULT";
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY"] = 1] = "INITIALIZE_IDENTITY";
    ShellLayout[ShellLayout["DEVICE_INVITATIONS"] = 2] = "DEVICE_INVITATIONS";
    ShellLayout[ShellLayout["SPACE_INVITATIONS"] = 3] = "SPACE_INVITATIONS";
    ShellLayout[ShellLayout["JOIN_SPACE"] = 4] = "JOIN_SPACE";
})(ShellLayout || (ShellLayout = {}));
//# sourceMappingURL=iframe.js.map